import { CircularProgress } from '@mui/material';
import { FC, Fragment } from 'react';

import NotificationCard from './NotificationCard';
import { NotificationsList as StyledNotificationsList } from './notifications.styles';
import { INotificationsList } from './notifications.types';

const NotificationsList: FC<INotificationsList> = ({
  notifications,
  updateNotification,
  removeNotification,
  sentinelIndex,
  getSentinelRef,
  isFetchingMore,
  onClose,
  listRef,
}) => (
  <StyledNotificationsList
    ref={listRef}
    onClick={(e) => {
      if (onClose) onClose(e, 'backdropClick');
    }}
  >
    {notifications?.map((notification, index) => (
      <Fragment key={notification._id}>
        <NotificationCard
          data={notification}
          updateNotification={updateNotification}
          removeNotification={removeNotification}
        />
        {/* Sentinel used for infinite scroll */}
        {index === sentinelIndex && (
          <li
            ref={(el) => {
              getSentinelRef(el);
            }}
            style={{ height: 0, padding: 0, listStyle: 'none' }}
          />
        )}
      </Fragment>
    ))}
    {isFetchingMore && (
      <li style={{ listStyle: 'none', padding: 0 }}>
        <CircularProgress size={20} sx={{ my: 1 }} />
      </li>
    )}
  </StyledNotificationsList>
);

export default NotificationsList;
